import React, { useState } from "react";
import "./Loader.css";
import bullDozer from '../src/image/Bulldozer.png'


import { Backdrop } from "@mui/material";


const Loader = () => {
  const [open, setOpen] = useState(true);


  return (
    <Backdrop
    sx={{
      backgroundColor: "#ffffff80",
      zIndex: 2000,
    }}
    open={open}
  >
 
<div id="img1" class="img loader" ></div>
<div id="img2" class="img loader"></div>
<div id="img3" class="img loader"></div>
<div id="img4" class="img loader"></div>
<div id="img5" class="img loader"></div>



  </Backdrop>
   

  );
};

export default Loader;